import { createSelector } from '@opengov/compose-app/reselect';

import { dimensionalTableActionCreators, dimensionalTableSelector, ILayoutBlockState } from '../state/';

export const selectLayoutBlockState = createSelector(
  dimensionalTableSelector,
  (dimensionalTableState): ILayoutBlockState => dimensionalTableState.layoutBlockState
);

export const selectDimensionalTableLayoutProps = createSelector(selectLayoutBlockState, (layoutBlockState) => ({
  expandedControlBlockIndex: layoutBlockState.expandedControlBlockIndex,
  selectLayoutDrawerState: layoutBlockState.isDrawerOpen,
  displayGlobalFilters: layoutBlockState.displayGlobalFilters,
  displayColumnFilters: layoutBlockState.displayColumnFilters,
  expandedColumnBlock: layoutBlockState.expandedColumnBlockIndex,
  changeDrawerVisibility: dimensionalTableActionCreators.changeDrawerVisibility,
  updateControlBlockIndex: dimensionalTableActionCreators.updateControlBlockIndex,
  changeGlobalFilterVisibility: dimensionalTableActionCreators.changeGlobalFilterVisibility,
  changeColumnFilterVisibility: dimensionalTableActionCreators.changeColumnFilterVisibility
}));

export const selectControlBlockProps = createSelector(dimensionalTableSelector, (dimensionalTableState) => {
  return dimensionalTableState.controlBlockModalState;
});

export const selectControlBlockStatus = createSelector(
  selectControlBlockProps,
  (controlBlockModalState) => controlBlockModalState.controlBlockStatus
);
